(() => {
  const tray = document.querySelector('[data-compare-tray]');
  if (!tray) return;

  const mobile = window.matchMedia('(max-width: 640px)');
  const header = tray.querySelector('.compare-tray__header');
  const copy = tray.querySelector('.compare-tray__copy');
  const actions = tray.querySelector('.compare-tray__actions');
  const items = tray.querySelector('[data-compare-tray-items]');
  const clear = tray.querySelector('[data-compare-clear]');
  const selectedCount = document.querySelector('[data-compare-mobile]')?.dataset.selectedCount;
  let disclosure;
  let panel;
  let chatButton;

  const syncChatControl = () => {
    const chat = document.querySelector('shopify-chat');
    const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
    const activator = chat?.shadowRoot?.querySelector('button[part~="activator"]')
      || runtime?.shadowRoot?.querySelector('button[part~="activator"]');
    const label = activator?.getAttribute('aria-label');
    const available = mobile.matches && !tray.hidden && document.querySelector('[data-compare-page]')
      && typeof chat?.show === 'function' && label;

    if (!available) {
      document.body.classList.remove('has-compare-chat-control');
      if (chatButton === document.activeElement) tray.querySelector('[data-compare-tray-cta]')?.focus();
      chatButton?.remove();
      chatButton = undefined;
      return;
    }

    if (!chatButton) {
      chatButton = document.createElement('button');
      chatButton.type = 'button';
      chatButton.className = 'button button--ghost compare-tray__chat';
      chatButton.setAttribute('aria-haspopup', 'dialog');
      chatButton.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true" focusable="false"><path d="M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7l-5 4v-4H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"/></svg>';
      chatButton.addEventListener('click', () => {
        const currentChat = document.querySelector('shopify-chat');
        if (typeof currentChat?.show === 'function') currentChat.show();
        else syncChatControl();
      });
      actions.append(chatButton);
    }
    const unread = activator.querySelector('.activator__indicator--active');
    const unreadLabel = unread?.getAttribute('aria-label');
    const accessibleLabel = unreadLabel ? `${label}. ${unreadLabel}` : label;
    chatButton.toggleAttribute('data-unread', Boolean(unread));
    chatButton.setAttribute('aria-label', accessibleLabel);
    chatButton.title = accessibleLabel;
    document.body.classList.add('has-compare-chat-control');
  };

  const setExpanded = (expanded) => {
    if (!panel) return;
    if (!expanded && panel.contains(document.activeElement)) disclosure.focus();
    panel.hidden = !expanded;
    disclosure.setAttribute('aria-expanded', String(expanded));
  };

  const enhanceTables = () => {
    const groups = document.querySelector('[data-compare-groups]');
    const cards = document.querySelector('[data-compare-cards]');
    if (!groups || !cards) return;

    // Keep reading and keyboard order aligned with the compact mobile layout.
    cards.before(groups);
    groups.querySelectorAll('table').forEach((table, tableIndex) => {
      table.setAttribute('role', 'table');
      const models = Array.from(table.querySelectorAll('thead th')).slice(1);
      table.style.setProperty('--compare-model-count', models.length);
      table.querySelectorAll('thead, tbody').forEach((section) => section.setAttribute('role', 'rowgroup'));
      table.querySelectorAll('tr').forEach((row) => row.setAttribute('role', 'row'));
      table.querySelectorAll('thead th').forEach((heading, index) => {
        heading.id = `CompareMobileHeader-${tableIndex}-${index}`;
        heading.setAttribute('role', 'columnheader');
      });
      table.querySelectorAll('tbody tr').forEach((row, rowIndex) => {
        const feature = row.querySelector('th');
        feature.id = `CompareMobileFeature-${tableIndex}-${rowIndex}`;
        feature.setAttribute('role', 'rowheader');
        row.querySelectorAll('td').forEach((cell, modelIndex) => {
          cell.setAttribute('role', 'cell');
          cell.setAttribute('headers', `${feature.id} ${models[modelIndex].id}`);
          if (cell.querySelector('.compare-mobile__model')) return;
          const label = document.createElement('span');
          label.className = 'compare-mobile__model';
          label.setAttribute('aria-hidden', 'true');
          label.textContent = models[modelIndex].textContent;
          cell.prepend(label);
        });
      });
    });
  };

  const restoreDesktop = () => {
    if (panel) {
      const focused = panel.contains(document.activeElement) || document.activeElement === disclosure;
      header.after(items);
      actions.prepend(clear);
      copy.hidden = false;
      panel.remove();
      disclosure.remove();
      panel = disclosure = undefined;
      tray.classList.remove('compare-tray--mobile');
      if (focused) tray.querySelector('[data-compare-tray-cta]').focus();
    }
    const groups = document.querySelector('[data-compare-groups]');
    const cards = document.querySelector('[data-compare-cards]');
    if (groups && cards) groups.before(cards);
    groups?.querySelectorAll('.compare-mobile__model').forEach((label) => label.remove());
    groups?.querySelectorAll('table').forEach((table) => {
      table.style.removeProperty('--compare-model-count');
      table.querySelectorAll('[headers]').forEach((cell) => cell.removeAttribute('headers'));
      table.querySelectorAll('[id^="CompareMobile"]').forEach((heading) => heading.removeAttribute('id'));
      [table, ...table.querySelectorAll('[role]')].forEach((element) => element.removeAttribute('role'));
    });
  };

  const refresh = () => {
    if (!mobile.matches) {
      if (disclosure) restoreDesktop();
      syncChatControl();
      return;
    }
    if (!panel) {
      disclosure = document.createElement('button');
      disclosure.type = 'button';
      disclosure.className = 'compare-tray__disclosure';
      disclosure.setAttribute('aria-controls', 'CompareMobileSelection');
      disclosure.setAttribute('aria-expanded', 'false');
      panel = document.createElement('div');
      panel.id = 'CompareMobileSelection';
      panel.className = 'compare-tray__panel';
      panel.hidden = true;
      header.prepend(disclosure);
      panel.append(items, clear);
      tray.append(panel);
      copy.hidden = true;
      tray.classList.add('compare-tray--mobile');
      disclosure.addEventListener('click', () => setExpanded(panel.hidden));
    }
    const countText = tray.querySelector('[data-compare-tray-count]').textContent;
    disclosure.textContent = selectedCount ? selectedCount.replace('{count}', items.children.length) : countText;
    disclosure.setAttribute('aria-label', countText);
    if (tray.hidden) setExpanded(false);
    enhanceTables();
    syncChatControl();
  };

  mobile.addEventListener('change', refresh);
  tray.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !panel || panel.hidden) return;
    event.preventDefault();
    setExpanded(false);
  });
  window.addEventListener('compare:updated', refresh);
  window.addEventListener('storage', refresh);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', (event) => {
    // Mobile browsers can restore an old selection UI from their back/forward cache.
    if (mobile.matches && event.persisted) window.dispatchEvent(new CustomEvent('compare:updated'));
  });
  // Inbox mounts asynchronously. Keep its native launcher until a working opener exists.
  if (document.querySelector('[data-compare-page]')) {
    const observedRoots = new WeakSet();
    const watchChat = () => {
      const chat = document.querySelector('shopify-chat');
      const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
      [chat?.shadowRoot, runtime?.shadowRoot].forEach((root) => {
        if (!root || observedRoots.has(root)) return;
        observedRoots.add(root);
        chatObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-label'] });
      });
      syncChatControl();
    };
    const chatObserver = new MutationObserver(watchChat);
    chatObserver.observe(document.body, { childList: true, subtree: true });
    customElements.whenDefined('shopify-chat').then(watchChat);
    customElements.whenDefined('shopify-agent-runtime').then(watchChat);
    watchChat();
  }
  refresh();
})();
